module.exports = __webpack_public_path__ + "e350a52ec148b661ab63f4e3e0c41ebb.png";